<template>
  <div class="no-data">
    <img :src="require('@img/no-data.png')">
    <div class="no-data-info">{{ info }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    info: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.no-data{
  padding: $paddingVertical $paddingHorizontal;
  img{
    display: block;
    max-width: 100%;
    margin: 0 auto 16px;
  }
  .no-data-info{
    color: $colorTextSecondary;
    text-align: center;
  }
}
</style>
